import { AGENCY } from "../data/agency";

export function AboutView() {
  return (
    <div className="px-8 pb-16">
      <header className="border-2 border-ink bg-red text-bone px-5 py-4 mb-4">
        <div className="font-mono text-xs text-bone/80">ID-01</div>
        <h2 className="font-display font-black uppercase text-4xl leading-none">
          IDENTIDADE INSTITUCIONAL
        </h2>
        <div className="font-serif italic mt-1 text-bone/80">
          {AGENCY.fullName} · {AGENCY.parent} · {AGENCY.city} · fundada em {AGENCY.founded}
        </div>
      </header>

      {/* MANIFESTO */}
      <section className="border-2 border-ink bg-bone p-8 mb-6">
        <div className="font-mono text-xs text-gold mb-2">MANIFESTO</div>
        <p className="font-serif italic text-2xl md:text-3xl leading-snug text-paper">
          “{AGENCY.manifesto}”
        </p>
        <div className="rule mt-6" />
        <div className="text-right tag text-graydk mt-2">— {AGENCY.tagline}</div>
      </section>

      {/* MISSAO + VISAO */}
      <div className="grid md:grid-cols-2 gap-4 mb-6">
        <article className="border-2 border-ink bg-bone overflow-hidden">
          <header className="bg-ink text-bone px-5 py-3">
            <div className="font-mono text-xs text-gold">MISSÃO</div>
            <div className="font-display font-black uppercase text-2xl leading-none">Por que existimos</div>
          </header>
          <p className="p-5 font-crimson italic text-lg leading-relaxed text-paper">
            {AGENCY.mission}
          </p>
        </article>

        <article className="border-2 border-ink bg-bone overflow-hidden">
          <header className="bg-gold text-ink px-5 py-3">
            <div className="font-mono text-xs">VISÃO</div>
            <div className="font-display font-black uppercase text-2xl leading-none">Onde vamos chegar</div>
          </header>
          <p className="p-5 font-crimson italic text-lg leading-relaxed text-paper">
            {AGENCY.vision}
          </p>
        </article>
      </div>

      {/* VALORES */}
      <section className="border-2 border-ink bg-bone">
        <header className="bg-ink text-bone px-5 py-3 flex items-center justify-between">
          <div>
            <div className="font-mono text-xs text-gold">VALORES</div>
            <div className="font-display font-black uppercase text-2xl leading-none">Como decidimos</div>
          </div>
          <div className="tag text-bone/70">{AGENCY.values.length} princípios</div>
        </header>
        <div className="grid md:grid-cols-2 xl:grid-cols-3 divide-x divide-y divide-ink/30">
          {AGENCY.values.map((v, i) => (
            <article key={v.id} className="p-5 bg-bone">
              <div className="flex items-baseline justify-between gap-2 mb-1">
                <div className="font-display font-black text-3xl text-red leading-none">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <span className="tag text-graydk">{v.id}</span>
              </div>
              <div className="font-display font-bold uppercase text-xl leading-tight mt-2">
                {v.title}
              </div>
              <p className="font-crimson italic text-paper text-sm mt-2 leading-relaxed">
                {v.description}
              </p>
            </article>
          ))}
        </div>
      </section>

      {/* FOOTER */}
      <div className="rule mt-6" />
      <p className="text-center font-mono text-[11px] uppercase tracking-wider text-graydk pt-3">
        documento institucional · {AGENCY.name} · {AGENCY.parent}
      </p>
    </div>
  );
}
